const redirectToUploadPortal = ($window) => {
  const url = `${$window.location.protocol}//${$window.location.host}/dokumente/`;
  $window.location.href = url;
};

export const zkgDocumentsState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    name: 'app.zkgDocuments',
    url: '/zkg-dokumente',
    controllerAs: 'vm',
    controller: redirectToUploadPortal,
  });
  $stateProvider.state({
    name: 'app.zkgDocumentsUpload',
    url: '/zkg-dokumente/upload',
    controllerAs: 'vm',
    controller: redirectToUploadPortal,
  });
};
